import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  IconButton,
  Typography,
  Box,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  Stack,
  useThemeProps,
} from "@mui/material";
import Logo from "../../assets/images/common/chat-logo.png";
import Link from "@mui/material/Link";
import Autocomplete from "@mui/material/Autocomplete";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid2";
import { useTheme } from "@mui/material/styles";
import { Logout } from "../../icons/icons";
import Myaccount from "../dashboard/pages/myaccount";
import Mywallet from "../dashboard/pages/mywallet";
import send from "../../assets/images/common/send-messege-img.svg";
import CircularProgress from "@mui/material/CircularProgress";
import { keyframes } from "@mui/system";

import {
  Newchat,
  Dropdown,
  Gemini,
  Chatlike,
  Chatdislike,
  Chatrefresh,
  Chatcopy,
  Sendmessege,
  Modalclose,
  Hamburguricon,
  Filleddiscopybtn,
} from "../../icons/icons";

import { useDispatch, useSelector } from "react-redux";
import {
  Balancereminder,
  ChatHistory,
  Clearchat,
  ConnetionHistory,
  ModelSelection,
  clearDisplayModels,
  resetChat,
  resetstatechat,
} from "../../redux/chatslice";
import Geminichat from "../../assets/images/common/gemini-chat-logo.png";
import Asklmschat from "../../assets/images/common/asklms-chat-logo.png";
import Mistralchat from "../../assets/images/common/mistral-chat-logo.png";
import Gemmachat from "../../assets/images/common/gemma-chat-logo.png";
import Addllmchat from "../../assets/images/common/add-llm-chat-logo.png";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import Chatgpt from "../../assets/images/common/chatgpt-logo.png";
import Geminilogo from "../../assets/images/common/gemini-logo.png";
import Gemma from "../../assets/images/common/gemma-logo.png";
import Mistral from "../../assets/images/common/mistral-logo.png";
import Websearch from "../../assets/images/common/web-search-logo.png";
import Tick from "../../assets/images/common/tick-icon.png";
import { SendChatQuery } from "../../redux/chatslice";
import { decryptUserId } from "../../utilis/encrypto";
// import BASE_URL from "../../common";
import { Lastchathistory, ModelReselect } from "../../redux/chatslice";
import { Logoutapi, resetLogin, resetState } from "../../redux/authSlice";
import Modelicon from "../../assets/images/common/model-icon.svg";
import { useNavigate } from "react-router-dom";
import Chat from "./chatmain";
import { Getprofile } from "../../redux/authSlice";
import { toast } from "react-toastify";

function MainChat() {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const { model } = useSelector((state) => state.chat);
  const [loading, setLoading] = useState(false);
  const { queryResponse, history, balance } = useSelector(
    (state) => state.chat
  );
  // console.log(history,"ll")
  const [textGeneration, setTextGeneration] = useState();
  // console.log(history, "text");
  const [reset, setReset] = useState(false);
  const [allResponses, setAllResponses] = useState([]);
  // console.log(allResponses, "eeee");
  const [propsconnection, setConnection] = useState({});
  const [lasthistory, setLasthistory] = useState({});
  // console.log(lasthistory, "lasthistory", propsconnection, "lasthistory");
  const [showllm, setShowllm] = useState("");
  const [submittedPrompt, setSubmittedPrompt] = useState("");
  const [lastTimestamp, setLastTimestamp] = useState(null);
  const [timestamp, setTimestamp] = useState();
  const [llmId, setLlmId] = useState();

  const dispatch = useDispatch();
  const [prompt, setPrompt] = useState("");
  const [selectedChat, setSelectedChat] = useState(null);
  const [chattingId, setChattingId] = useState(null);
  const [imageGeneration, setImageGeneration] = useState([]);
  const [activeComponent, setActiveComponent] = useState("chat"); // Default to 'chat'
  const { getprofile } = useSelector((state) => state.admin);
  const [showLowBalanceModal, setShowLowBalanceModal] = useState(false);
  const { selectedOption, showRecentSearches } = useSelector(
    (state) => state.sidebar
  ); // Access sidebar state
  const openLow = () => {
    setActiveComponent("wallet");
  };

  // Function to close the modal

  // console.log(getprofile, "getpro")
  const [firstLetter, setFirstLetter] = useState("");
  useEffect(() => {
    dispatch(Balancereminder());
  }, [dispatch]);

  useEffect(() => {
    if (balance.status_code === 200 && balance.required_recharge === true) {
      setShowbalance(true);
    } else {
      setShowbalance(false);
    }
  }, [balance.status_code, balance.required_recharge]);
  useEffect(() => {
    const letter = getprofile?.name?.charAt(0).toUpperCase() || "";
    setFirstLetter(letter);
    // console.log(letter, "first letter of name (capitalized)");
  }, [getprofile]);

  useEffect(() => {
    dispatch(Getprofile());
  }, [dispatch]);
  const handleShowAccount = () => {
    setActiveComponent("myaccount");
  };

  const handleShowWallet = () => {
    setActiveComponent("wallet");
  };

  const handleShowChat = () => {
    setActiveComponent("chat");
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (model.text_model?.length > 0) {
      setTextGeneration(model.text_model);
    }
  }, [model.text_model]);

  useEffect(() => {
    if (model.image_model) {
      setImageGeneration(model.image_model);
    }
  }, [model.image_model]);

  useEffect(() => {
    const currentTimestamp = Date.now();
    setTimestamp(currentTimestamp);
  }, [setTimestamp]);

  const handleClickChatmodel = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseChatmodel = () => {
    setAnchorEl(null);
  };

  const handleClickChat = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseChat = () => {
    setAnchorEl(null);
  };

  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChatClick = (chat) => {
    setSelectedChat(chat);
    // console.log(chat, "fffttt");
    // Convert timestamp to string for the API payload
    const timestamp = chat.timestamp.toString();
    setLastTimestamp(timestamp);
    localStorage.setItem("lastTimestamp", timestamp);
    //connect
    // console.log(timestamp,"time")
    const chatid = Array.isArray(chat.llm_id) ? chat.llm_id[0] : chat.llm_id;
    // console.log(chatid,"chatid")
    const llmId = chat.llm_id;
    // console.log(llmId,"llmid")
    setShowllm(llmId);
    //last
    const selectedModels = textGeneration
      .filter((item) => item.isSelected)
      .map((item) => item.id.toString());

    const llmIs =
      selectedModels.length > 0 ? selectedModels : ["default_llm_type"];
    const llmI = llmIs[0];

    const encryptedUserId = localStorage.getItem("userId");
    const userId = decryptUserId(encryptedUserId);

    if (!userId) {
      console.error("Failed to decrypt user ID.");
      return;
    }

    const connectionPayload = {
      user_id: userId,
      timestamps: timestamp,
      llm_ids: llmId,
    };
    setConnection(connectionPayload);
    const lastChatPayload = {
      user_id: userId,
      timestamps: timestamp,
      llm_id: llmI,
    };
    setLasthistory(lastChatPayload);
    dispatch(ConnetionHistory(connectionPayload))
      .then((connectionResponse) => {
        if (connectionResponse.error) {
          console.error("ConnectionHistory failed:", connectionResponse.error);
          return;
        }

        dispatch(Lastchathistory(lastChatPayload)).then((response) => {
          if (response.payload && response.payload.data) {
            const fetchedChatHistory = response.payload.data;
            setAllResponses(fetchedChatHistory);

            if (
              activeComponent === "myaccount" ||
              activeComponent === "wallet"
            ) {
              setActiveComponent("chat");
            } else {
              console.log(
                "Active component is not 'myaccount' or 'wallet', skipping reload."
              );
            } // console.log(response.payload.data, "Fetched on chat click");
          }
        });
      })
      .catch((error) => {
        console.error("Error in ConnectionHistory:", error);
      });
  };
  const handleModelClick = (modelId) => {
    // console.log("Clicked chat with model ID:", modelId);
    setChattingId(modelId);
    const selectedModel = textGeneration.find((item) => item.id === modelId);
    if (!selectedModel) {
      console.error("Model not found with ID:", modelId);
      return;
    }
    setSelectedChat(selectedModel);

    const storedTimestamp = localStorage.getItem("lastTimestamp");
    const timestamp = storedTimestamp || selectedModel.timestamp;

    setLastTimestamp(timestamp);
    localStorage.setItem("lastTimestamp", timestamp);
    // console.log("Timestamp used:", timestamp);

    const encryptedUserId = localStorage.getItem("userId");
    const userId = decryptUserId(encryptedUserId);

    if (!userId) {
      console.error("Failed to decrypt user ID.");
      return;
    }

    if (selectedModel.text_model?.length > 0) {
      setTextGeneration(selectedModel.text_model);
    }

    const lastChatPayload = {
      user_id: userId,
      timestamps: timestamp,
      llm_id: modelId.toString(),
    };

    // console.log("Payload to be sent:", lastChatPayload);

    dispatch(Lastchathistory(lastChatPayload)).then((response) => {
      if (response.payload && response.payload.data) {
        const fetchedChatHistory = response.payload.data;
        setAllResponses(fetchedChatHistory);
        // console.log("Fetched chat history:", fetchedChatHistory);
      }
    });
  };

  const clearshowllm = () => {
    setShowllm();
  };

  useEffect(() => {
    const lastTimestamp = localStorage.getItem("lastTimestamp");
    const lastChat = history.find((chat) => chat.timestamp === lastTimestamp);
    if (lastChat) {
      setSelectedChat(lastChat);
    }
  }, [history]);

  useEffect(() => {
    dispatch(ChatHistory());
  }, [dispatch]);

  useEffect(() => {
    const storedTimestamp = localStorage.getItem("lastTimestamp");

    if (storedTimestamp) {
      setTimestamp(storedTimestamp);
    } else {
      const newTimestamp = Date.now();
      setTimestamp(newTimestamp);
      localStorage.setItem("lastTimestamp", newTimestamp);
    }
  }, []);

  const handleChange = (e) => setPrompt(e.target.value);

  const handleSubmit = () => {
    if (!Array.isArray(textGeneration) || !Array.isArray(imageGeneration)) {
      console.error("One of the model arrays is not an array:", {
        textGeneration,
        imageGeneration,
      });
      return;
    }

    // Collect selected model IDs from text generation and image generation
    const selectedTextModels = textGeneration
      .filter((item) => item.isSelected)
      .map((item) => item.id.toString());

    const selectedImageModels = imageGeneration
      .filter((item) => item.isSelected)
      .map((item) => item.id.toString());

    // Check if at least one model is selected
    if (selectedTextModels.length === 0 && selectedImageModels.length === 0) {
      console.error("No models selected. Please select at least one LLM.");
      return;
    }
    const textImageSelection = selectedImageModels.length > 0;

    const llmType =
      selectedTextModels.length > 0
        ? selectedTextModels
        : selectedImageModels.length > 0
        ? selectedImageModels
        : ["default_llm_type"];

    const encryptedUserId = localStorage.getItem("userId");
    const userId = decryptUserId(encryptedUserId);

    if (!userId) {
      console.error("Failed to decrypt user ID.");
      return;
    }

    setSubmittedPrompt(prompt);
    const llmId = llmType[0];
    setLlmId(llmId);

    const payload = {
      llm_type: llmType,
      query: prompt,
      user_id: userId,
      regenerate: false,
      Text_image_selection: textImageSelection,
      isMine: true,
      timestamps: timestamp,
    };

    setAllResponses((prevResponses) => [...prevResponses, payload]);

    setLoading(true);
    dispatch(SendChatQuery(payload)).finally(() => {
      setLoading(false);
    });

    setLastTimestamp(timestamp);
    localStorage.setItem("lastTimestamp", timestamp);
    setPrompt("");
  };

  useEffect(() => {
    const encryptedUserId = localStorage.getItem("userId");
    const userId = decryptUserId(encryptedUserId);

    if (!userId) {
      console.error("Failed to decrypt user ID.");
      return;
    }

    // if (model.text_model?.length > 0) {
    //   setTextGeneration(model.text_model);
    // }

    if (!Array.isArray(textGeneration)) {
      console.error("textGeneration is not an array:", textGeneration);
      return;
    }

    const selectedModels = textGeneration
      .filter((item) => item.isSelected)
      .map((item) => item.id.toString());

    const llmType =
      selectedModels.length > 0 ? selectedModels : ["default_llm_type"];
    const llmId = llmType[0];

    const storedTimestamp = localStorage.getItem("lastTimestamp");
    //  console.log(storedTimestamp, "storedTimestamp", llmId);

    if (storedTimestamp && llmId) {
      const payload = {
        user_id: userId,
        timestamps: storedTimestamp,
        llm_id: llmId,
      };
      dispatch(Lastchathistory(payload)).then((response) => {
        if (response.payload && response.payload.data) {
          const fetchedChatHistory = response.payload.data;
          setAllResponses(fetchedChatHistory);
          // console.log(response.payload.data, "rrrr");
        }
      });
    }
  }, [model, textGeneration, dispatch]);

  useEffect(() => {
    dispatch(ModelSelection());
  }, [dispatch]);

  const handleNavigate = (path) => {
    navigate(path);
    handleCloseChat();
  };
  useEffect(() => {
    if (reset) {
      // console.log("Resetting allResponses", allResponses);
      setAllResponses([]);
      setLastTimestamp("");
      localStorage.removeItem("lastTimestamp");
      setSelectedChat(null);
      setPrompt("");
      // dispatch(ModelSelection());

      // dispatch(Clearchat());
      setSubmittedPrompt("");
      setReset(false); // Reset back to false after clearing
    }
  }, [reset, dispatch]);

  const handleNewChat = () => {
    setReset(true);
    dispatch(ModelSelection());
    // console.log("Initiating reset...");
    setActiveComponent("chat");
    dispatch(resetChat());
  };

  // console.log(showllm, "history");

  useEffect(() => {
    if (model.text_model?.length > 0) {
      setTextGeneration(model.text_model);
    }
  }, [model]);

  const [openD, setOpenD] = React.useState(false);
  const [showbalance, setShowbalance] = useState(false);

  const handleClickOpenD = () => {
    setOpenD(true);
  };

  const handleCloseD = () => {
    setOpenD(false);
  };
  const handleBalance = () => {
    setActiveComponent("wallet");
    setShowbalance(false);
  };
  const handleBalanceopen = () => {
    setActiveComponent("wallet");
    setShowbalance(true);
  };

  const handleBalanceclose = () => {
    setShowbalance(false);
  };
  const [openB, setOpenB] = React.useState(false);

  const handleClickOpenB = () => {
    setOpenB(true);
  };

  const handleCloseB = () => {
    setOpenB(false);
  };

  // useEffect(() => {
  //   if (queryResponse && queryResponse.status === "success") {
  //     const responseMessage = queryResponse.data.message;
  //     const responseImageUrl = queryResponse.data.image_url || []; // Capture image URL if available
  //     // console.log(responseImageUrl, "responseImageUrl");
  //     let payload = {
  //       query: responseMessage,
  //       isMine: false,
  //       image_url: responseImageUrl,
  //     };

  //     setAllResponses((prevResponses) => [...prevResponses, payload]);
  //   }
  // }, [queryResponse]);

  // useEffect(() => {
  //   if (queryResponse) {
  //     console.log("Query Response:", queryResponse);
  //   }
  //   // console.log(queryResponse?.data, "queryResponse.data");
  //   if (queryResponse && queryResponse.status === "success") {
  //     const responseMessage = queryResponse.data.message;

  //     console.log("Submitted Prompt:", submittedPrompt);
  //     console.log("Response Message:", responseMessage);
  //     let payload = {
  //       query: responseMessage,
  //       isMine: false,
  //     };

  //     setAllResponses((prevResponses) => [...prevResponses, payload]);
  //   }
  // }, [queryResponse]);
  // const handleLogout = () => {
  //   // Dispatch the Logout API
  //   dispatch(Logoutapi())
  //     .unwrap()
  //     .then(() => {
  //       // Clear local storage only after successful logout
  //       localStorage.removeItem('userId');
  //       localStorage.removeItem('lastTimestamp');
  //       localStorage.clear();
  
  //       // Reset Redux state after a successful log
  //       dispatch(resetChat());
  //       dispatch(resetLogin());
  
  //       // Navigate to login page
  //       navigate('/login');
  //     })
  //     .catch((error) => {
  //       console.error('Logout failed:', error);
  //       // Optionally show an error notification to the user
  //     });
  // };
  
  const handleLogout = () => {
    localStorage.removeItem('userId');
       localStorage.removeItem('lastTimestamp');
    localStorage.clear(); 
    // window.location.href = '/asklms/login'
    window.location.href = '/login'
    toast.success("Logged-out")
  }
  

  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  return (
    <>
      <Box sx={{ display: "flex" }}></Box>
      <Stack
        direction={"row"}
        justifyContent={"start"}
        alignContent={"stretch"}
        height={"100vh"}
      >
        <Stack
          sx={{
            width: sidebarOpen ? { xs: "250px", xl: "330px" } : "0",
            position: sidebarOpen ? { xs: "fixed", sm: "static" } : "static",

            display: sidebarOpen ? "flex" : "none",
            // width: { xs: "0", sm: '250px', xl: "330px" },
            zIndex: "999",
            height: "100%",
            background: theme.palette.primary.primary2,
          }}
          justifyContent={"space-between"}
        >
          <Box>
            <Box
              sx={{
                p: { xs: "10px  22px", lg: "12px  22px", xl: "20px  22px" },
                minHeight: { xs: "65px", lg: "69px", xl: "85px" },
                borderBottom: "1px solid",
                borderBottomColor: theme.palette.primary.main,
              }}
            >
              <img src={Logo} alt="logo" />

              <Button
                type="button"
                onClick={toggleSidebar}
                sx={{
                  display: {
                    xs: "block",
                    sm: "none",
                    position: "absolute",
                    top: 0,
                    right: 0,
                    color: "#fff",
                  },
                }}
              >
                X
              </Button>
            </Box>

            <Box sx={{ p: { xs: "10px 0", xl: "28px 0" }, overflow: "auto" }}>
              <Box sx={{ p: "18px 24px " }}>
                <Button
                  sx={{
                    mr: 1,
                    color: "#fff",
                    borderRadius: "50px",
                    background: theme.palette.primary.main,
                    padding: { xs: "6px 20px ", xl: "10px 30px" },
                    fontSize: { xs: "14px", xl: "16px" },
                    fontWeight: "700",
                    height: "auto",
                  }}
                  onClick={handleNewChat}
                  endIcon={<Newchat />}
                >
                  New Chat
                </Button>
              </Box>
              {textGeneration &&
              textGeneration.some((item) => item.isSelected) ? (
                showRecentSearches ? (
                  <>
                    <Box sx={{ p: { xs: "8px 24px", xl: "14px 24px" } }}>
                      <Typography
                        variant="p"
                        sx={{
                          color: theme.palette.disablegrey.gray1,
                          fontSize: "16px",
                          fontWeight: "700",
                        }}
                        fullWidth
                      >
                        Recent Searches
                      </Typography>
                    </Box>
                    <Box
                      component="ul"
                      sx={{
                        maxHeight: {
                          xs: "200px",
                          sm: "300px",
                          lg: "180px",
                          xl: "300px",
                        },
                        minHeight: {
                          xs: "auto",
                          sm: "auto",
                          lg: "auto",
                          xl: "auto",
                        },
                        Height: {
                          xs: "200px",
                          sm: "300px",
                          lg: "180px",
                          xl: "300px",
                        },
                        overflow: "auto",
                        listStyle: "none",
                        padding: 0,
                        margin: 0,
                        "& li": {
                          color: theme.palette.secondary.main,
                          fontWeight: "400",
                          fontSize: "16px",
                          p: { xs: "6px 10px ", xl: "14px 24px " },
                          borderLeft: "4px solid",
                          borderLeftColor: "transparent",
                          cursor: "pointer",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          "&:hover": {
                            color: theme.palette.white.white,
                            borderLeft: "4px solid",
                            borderLeftColor: theme.palette.primary.main,
                            background: theme.palette.primary.light,
                            fontWeight: "500",
                          },
                        },
                      }}
                    >
                     

                      {history?.map((chat, index) => (
                        <li key={index} onClick={() => handleChatClick(chat)}>
                          {chat.in_msg}
                        </li>
                      ))}
                    </Box>
                  </>
                ) : null
              ) : null}

              <Box
                component="ul"
                sx={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  pt: "20px",
                }}
              >
                <li>
                  <Stack direction={"row"} alignItems={"center"} spacing={2}>
                    {/* <Box sx={{ mr: '12px' }}> <Myaccount /></Box> */}
                    <Link
                      to="myaccount"
                      onClick={handleShowAccount}
                      style={{
                        textDecoration: "none",
                        width: "100%",
                      }}
                    >
                      {" "}
                      <Typography
                        variant="P"
                        sx={{
                          display: "block",
                          fontSize: "16px",
                          p: { xs: "14px 10px ", xl: "14px 24px " },
                          borderLeft: "4px solid",
                          cursor: "pointer",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          background:
                            activeComponent === "myaccount"
                              ? theme.palette.primary.light
                              : "transparent",

                          borderLeftColor:
                            activeComponent === "myaccount"
                              ? theme.palette.primary.main
                              : "transparent",
                          fontWeight:
                            activeComponent === "myaccount" ? "500" : "400",
                          color:
                            activeComponent === "myaccount"
                              ? theme.palette.white.white
                              : theme.palette.secondary.main,

                          fontWeight: "500",
                          fontSize: "16px",

                          // "&:hover": {
                          //   color: theme.palette.white.white,
                          //   borderLeftColor: theme.palette.primary.main,
                          //   background: theme.palette.primary.light,
                          //   fontWeight: "500",
                          // },
                          // color: activeComponent === "myaccount"
                          //   ? theme.palette.primary.main
                          //   : theme.palette.secondary.main,
                        }}
                      >
                        My Account
                      </Typography>
                    </Link>
                  </Stack>
                </li>
                <li>
                  <Stack direction={"row"} alignItems={"center"} spacing={2}>
                    {/* <Box sx={{ mr: '12px' }}> <Mywallet /></Box> */}
                    <Link
                      to="#"
                      onClick={handleShowWallet}
                      style={{ textDecoration: "none", width: "100%" }}
                    >
                      <Typography
                        variant="p"
                        sx={{
                          // color: activeComponent === "wallet"
                          //   ? theme.palette.primary.main
                          //   : theme.palette.secondary.main,

                          display: "block",
                          fontSize: "16px",
                          p: { xs: "14px 10px ", xl: "14px 24px " },
                          borderLeft: "4px solid",
                          cursor: "pointer",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          background:
                            activeComponent === "wallet"
                              ? theme.palette.primary.light
                              : "transparent",

                          borderLeftColor:
                            activeComponent === "wallet"
                              ? theme.palette.primary.main
                              : "transparent",
                          fontWeight:
                            activeComponent === "wallet" ? "500" : "400",
                          color:
                            activeComponent === "wallet"
                              ? theme.palette.white.white
                              : theme.palette.secondary.main,

                          fontWeight: "500",
                          fontSize: "16px",
                        }}
                      >
                        My Wallet
                      </Typography>
                    </Link>
                  </Stack>
                </li>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              p: "24px  22px",
              borderTop: "1px solid",
              borderTopColor: theme.palette.primary.main,
            }}
            onClick={handleLogout}
          >
            <Link
              href="#"
              sx={{
                color: theme.palette.secondary.main,
                fontWeight: "700",
                fontSize: "16px",
                display: "inline-flex",
                alignItems: "center",
                "&:hover": {
                  textDecoration: "none",
                },
              }}
            >
              {" "}
              <Box sx={{ mr: "8px" }}>
                <Logout />
              </Box>
              Logout
            </Link>
          </Box>
        </Stack>

        <Box
          sx={{
            width: {
              xs: "100%",
              sm: "calc( 100% - 250px)",
              xl: "calc( 100% - 330px)",
            },
            height: "100%",
          }}
        >
          <Box
            sx={{
              overflow: "auto",
              background: theme.palette.primary.primary4,
              height: "100%",
              paddingBottom: { xs: "80px", xl: "140px" },
              paddingTop: { xs: "64px", lg: "69px", xl: "80px" },
              position: "relative",
            }}
          >

            <Stack
              direction={"row"}
              justifyContent={{ xs: "space-between", sm: "end" }}
              alignItems={"center"}
              sx={{
                p: { xs: "10px", lg: "12px  20px", xl: "20px  32px" },
                minHeight: { xs: "65px", lg: "69px", xl: "85px" },
                borderBottom: "1px solid",
                // borderBottomColor: theme.palette.primary.main,
                borderBottomColor: theme.palette.border.border2,
                background: theme.palette.primary.primary4,
                position: "fixed",
                top: 0,
                left: { xs: "0", sm: "250px", xl: "330px" },
                right: 0,
                zIndex: "99",
              }}
            >
              <Button
                type="button"
                sx={{
                  p: 0,
                  minWidth: "auto",
                  height: "auto",
                  display: { xs: "block", sm: "none" },
                  mr: "10px",
                }}
                onClick={toggleSidebar}
              >
                <Hamburguricon />
              </Button>

              <Box sx={{ display: { xs: "block", sm: "none" } }}>
                <img src={Logo} alt="logo" />
              </Box>

              {/* <Box sx={{ display: { xs: "none", sm: "block" } }}>
                <Stack
                  direction={"row"}
                  alignItems={"center"}
                  id="basic-button"
                  aria-controls={open ? "basic-menumodels" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClickChatmodel}
                  sx={{
                    position: "relative",
                    p: { xs: "10px", sm: "10px 20px" },
                    cursor: "pointer",
                    background: theme.palette.primary.morelight,
                    borderRadius: "50px",
                  }}
                >
                  <Typography
                    variant="p"
                    sx={{
                      color: theme.palette.secondary.main,
                      fontWeight: "700",
                      fontSize: "16px",
                      mr: "10px",
                    }}
                    fullWidth
                  >
                    Models
                  </Typography>
                  <Dropdown />
                  <Box
                    sx={{
                      position: "absolute",
                      top: "-2px",
                      right: "-2px",
                      width: "18px",
                      height: "18px",
                      fontSize: "14px",
                      fontWeight: "700",
                      background: "#FF0000",
                      borderRadius: "50%",
                      color: theme.palette.white.white,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  ></Box>
                </Stack>
              </Box> */}

              <Button
                direction={"row"}
                justifyContent={"center"}
                alignItems={"center"}
                sx={{
                  width: "40px",
                  height: "40px",
                  textAlign: "center",
                  borderRadius: "50%",
                  fontSize: "18px",
                  fontWeight: "700",
                  color: theme.palette.white.white,
                  background: theme.palette.primary.main,
                  cursor: "pointer",
                  ml: "24px",
                  minWidth: "40px",
                }}
                aria-controls={open ? "basic-menuChat" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClickChat}
              >
                {firstLetter}
              </Button>

              {/* <Menu
                id="basic-menuChat"
                anchorEl={anchorEl}
                open={open}
                onClose={handleCloseChat}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <MenuItem onClick={() => handleNavigate("/dashboard")}>
                  My Profile
                </MenuItem>
              </Menu> */}
            </Stack>
            
            <Dialog
              open={showbalance}
              onClose={handleBalanceclose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              sx={{
                "& .css-umy2on-MuiPaper-root-MuiDialog-paper": {
                  width: "375px",
                },
              }}
            >
              <DialogTitle id="alert-dialog-title" sx={{ p: 0 }}>
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  sx={{
                    borderBottom: "1px solid",
                    borderBottomColor: theme.palette.greyshades.grey100,
                    pb: "12px",
                  }}
                >
                  <Typography
                    variant="p"
                    sx={{
                      color: theme.palette.secondary.main,
                      fontWeight: "700",
                      fontSize: "18px",
                    }}
                  >
                    Top Up Wallet
                  </Typography>
                  <DialogActions>
                    <Button
                 onClick={handleBalanceclose}
                      sx={{ p: 0, minWidth: "auto", height: "auto" }}
                    >
                      <Modalclose   onClick={handleBalanceclose}
/>
                    </Button>
                  </DialogActions>
                </Stack>
              </DialogTitle>

              <DialogContent sx={{ p: 0 }}>
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  sx={{ p: "12px 0 0px 0" }}
                >
                  <Typography
                    variant="p"
                    sx={{
                      color: theme.palette.secondary.main,
                      fontWeight: "400",
                      fontSize: "18px",
                    }}
                  >
                    Your account balance is low. It is advised to top up your
                    wallet
                  </Typography>
                </Stack>

                <Grid
                  container
                  spacing={"12px"}
                  justifyContent={"start"}
                  alignItems={"stretch"}
                  columns={2}
                  sx={{ p: "32px 0 0px 0" }}
                >
                  <Grid size={{ xs: 1, xl: 1 }}>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      fullWidth
                      sx={{
                        p: "10px 22px",
                        backgroundColor: "primary.Main",
                        fontSize: "16px",
                        fontWeight: "500",
                        borderRadius: "50px",
                        height: "auto",
                      }}
                      onClick={handleBalance}
                    >
                      Top up wallet
                    </Button>
                  </Grid>
                  <Grid size={{ xs: 1, xl: 1 }}>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      fullWidth
                      sx={{
                        p: "10px 22px",
                        backgroundColor: "transparent",
                        fontSize: "16px",
                        fontWeight: "500",
                        borderRadius: "50px",
                        border: "1px solid #fff",
                        height: "auto",
                      }}
                      onClick={handleBalanceclose}
                    >
                      Remind me later
                    </Button>
                  </Grid>
                </Grid>
              </DialogContent>
            </Dialog>

            {activeComponent === "chat" && (
              <Chat
                setAllResponses={setAllResponses}
                reset={reset}
                allResponses={allResponses}
                historyData={lasthistory}
                connection={propsconnection}
                chatid={showllm}
                onClear={clearshowllm}
                active={openLow}
              />
            )}
            {activeComponent === "myaccount" && <Myaccount   onClear={clearshowllm}/>}
            {activeComponent === "wallet" && <Mywallet />}
          </Box>
        </Box>
      </Stack>
    </>
  );
}

export default MainChat;
